import { format as dateFnsFormat } from 'date-fns';
import locale from 'date-fns/locale/en-US';
import svLocale from 'date-fns/locale/sv';

export const format = (date: Date, formatStr: string) =>
    dateFnsFormat(date, formatStr, {
        locale: svLocale
    });

export const toDateTimeString = (date: Date | string | null | undefined) =>
    toDateString(date, 'yyyy-MM-dd HH:mm');

export const toDateString = (date: Date | string | null | undefined, dateFormatStr?: string) => {
    if (date == null) {
        return '';
    }

    if (!(date instanceof Date)) {
        date = new Date(date);
    }
    return format(date, dateFormatStr ?? 'yyyy-MM-dd');
};

export const weekdays = Array.from(Array(7).keys()).map(
    i => [i, locale.localize!.day(i, { width: 'abbreviated' })] as const
);

// Move sunday to end of array
const sunday = weekdays[0];
weekdays.splice(0, 1);
weekdays.push(sunday);
